/* eslint-disable import/no-anonymous-default-export */
import contactUs from "./contact-us";

export default { contactUs };
